import getLangData from './get-language-data';

const getUsedLanguages = (locales, languages, countries) =>
  locales.map((locale) => getLangData(locale, languages, countries));

export default getUsedLanguages;
